import { Box } from "@mui/material";
import React from "react";
import Text from "../../../../../components/Text";
import { ABNORMAL_FLAG_OPTIONS_MAPPER } from "../../../../../pages/app/provider/patient/patient-list/patient-chart-new/order/result/UpsertResultNew";
import { formatDate } from "../../../../../utils/date-time-utility";
import { COLORS } from "../constants";
import { Report, ReportActions } from "../patient-portal-dashboard.types";
import Badge from "./shared/Badge";

interface ReportItemProps {
  report: Report;
  actions?: ReportActions;
}

const ReportItem: React.FC<ReportItemProps> = ({ report, actions }) => {
  // const [patient] = useCurrentUser();
  // const timezone = patient?.timezone as TimezoneEnum | undefined;

  const isClickable = !!actions?.onView;
  const badgeLabel = report.abnormalFlag
    ? ABNORMAL_FLAG_OPTIONS_MAPPER[report.abnormalFlag]
    : undefined;

  return (
    <Box
      onClick={isClickable ? () => actions?.onView?.(report) : undefined}
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        py: 1.5,
        borderBottom: `1px solid ${COLORS.border}`,
        cursor: isClickable ? "pointer" : "default",
        "&:last-child": { borderBottom: "none" },
        "&:hover": isClickable ? { backgroundColor: COLORS.background } : {},
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
        <Text size="14px" c={COLORS.textPrimary}>
          {report.reportName || "-"}
        </Text>
        {badgeLabel && <Badge label={badgeLabel} variant="error" />}
      </Box>
      <Text size="14px" c={COLORS.textSecondary}>
        {report.recordedDate ? formatDate(report.recordedDate) : "-"}
      </Text>
    </Box>
  );
};

export default ReportItem;
